export default __webpack_public_path__ + "static/media/DNo.32-1.c0971771.jpg";